(async () => {
  const container = document.querySelector(".js-sitemap-accordion");
  if (!container) return;

  const mainSitemapUrl = "/sitemap.xml";
  const DURATION = 300;

  async function fetchXML(url) {
    const res = await fetch(url);
    const text = await res.text();
    return new DOMParser().parseFromString(text, "application/xml");
  }

  function extractLocs(xml) {
    return Array.from(xml.querySelectorAll("loc")).map(n => n.textContent.trim());
  }

  function buildTree(urls, basePath) {
    const tree = {};

    urls
      .filter(url => new URL(url).pathname.startsWith(basePath))
      .forEach(url => {
        const path = new URL(url).pathname.replace(basePath, "");
        const segments = path.split("/").filter(Boolean);

        let current = tree;
        segments.forEach((segment, index) => {
          if (!current[segment]) current[segment] = { __url: null };
          current = current[segment];

          if (index === segments.length - 1) current.__url = url;
        });
      });

    return tree;
  }

  function renderAccordion(title, tree) {
    const wrapper = document.createElement("div");
    wrapper.className = "product-accordion js-product-accordion border-brand-300 text-brand-600";

    wrapper.innerHTML = `
      <div class="product-accordion__title js-toggle-product-accordion" tabindex="0">
        <h3>${title}</h3>
        <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.72441 11.8692L1.43274 8.5775C1.35587 8.49791 1.26391 8.43442 1.16224 8.39075C1.06057 8.34707 0.951224 8.32409 0.840575 8.32312C0.729925 8.32216 0.620192 8.34325 0.517778 8.38515C0.415365 8.42705 0.322322 8.48893 0.244078 8.56717C0.165834 8.64541 0.103956 8.73846 0.0620557 8.84087C0.0201549 8.94328 -0.00093005 9.05302 3.14637e-05 9.16367C0.000992977 9.27432 0.0239816 9.38367 0.0676557 9.48534C0.11133 9.58701 0.174815 9.67896 0.254407 9.75583L4.96857 14.47C5.12485 14.6262 5.33677 14.714 5.55774 14.714C5.77871 14.714 5.99063 14.6262 6.14691 14.47L10.8611 9.75583C11.0129 9.59866 11.0969 9.38816 11.095 9.16967C11.0931 8.95117 11.0054 8.74216 10.8509 8.58765C10.6964 8.43314 10.4874 8.3455 10.2689 8.34361C10.0504 8.34171 9.83991 8.4257 9.68274 8.5775L6.39107 11.8692V0.833333C6.39107 0.61232 6.30328 0.400358 6.147 0.244078C5.99072 0.0877973 5.77875 0 5.55774 0C5.33673 0 5.12477 0.0877973 4.96848 0.244078C4.8122 0.400358 4.72441 0.61232 4.72441 0.833333V11.8692Z" fill="currentColor"/>
        </svg>
      </div>
      <div class="product-accordion__content js-product-accordion-content"></div>
    `;

    const content = wrapper.querySelector(".js-product-accordion-content");
    content.appendChild(renderTree(tree));

    return wrapper;
  }

  function renderTree(tree) {
    const ul = document.createElement("ul");

    for (const key in tree) {
      if (key === "__url") continue;

      const node = tree[key];
      const li = document.createElement("li");

      const text = key.replace(/[-_]/g, " ");

      li.innerHTML = node.__url
        ? `<a href="${node.__url}">${text}</a>`
        : `<span>${text}</span>`;

      const children = renderTree(node);
      if (children.children.length) li.appendChild(children);

      ul.appendChild(li);
    }

    return ul;
  }

  function initAccordion(root) {
    const toggleAccordion = (toggle) => {
      const parent = toggle.closest(".js-product-accordion");
      if (!parent) return;

      parent.classList.toggle("active");

      const content = parent.querySelector(".js-product-accordion-content");
      if (!content || content.dataset.animating === "true") return;

      const isOpen = content.classList.contains("is-open");
      content.dataset.animating = "true";

      if (isOpen) {
        const h = content.scrollHeight;
        content.style.height = h + "px";
        content.offsetHeight;
        content.style.transition = `height ${DURATION}ms ease`;
        content.style.height = "0px";

        setTimeout(() => {
          content.style.display = "none";
          content.style.height = "";
          content.classList.remove("is-open");
          content.dataset.animating = "false";
        }, DURATION);

      } else {
        content.style.display = "block";
        const target = content.scrollHeight;
        content.style.height = "0px";
        content.offsetHeight;
        content.style.transition = `height ${DURATION}ms ease`;
        content.style.height = target + "px";

        setTimeout(() => {
          content.style.height = "";
          content.classList.add("is-open");
          content.dataset.animating = "false";
        }, DURATION);
      }
    };

    root.addEventListener("click", (e) => {
      const toggle = e.target.closest(".js-toggle-product-accordion");
      if (toggle) toggleAccordion(toggle);
    });

    root.addEventListener("keydown", (e) => {
      const toggle = e.target.closest(".js-toggle-product-accordion");
      if (!toggle) return;

      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        toggleAccordion(toggle);
      }
    });
  }

  const mainXML = await fetchXML(mainSitemapUrl);
  const sitemapFiles = extractLocs(mainXML);

  let allLocs = [];
  for (const file of sitemapFiles) {
    const xml = await fetchXML(file);
    allLocs.push(...extractLocs(xml));
  }

  const collectionsTree = buildTree(allLocs, "/collections/");
  const productsTree = buildTree(allLocs, "/products/");
  const pagesTree = buildTree(allLocs, "/pages/");
  const blogsTree = buildTree(allLocs, "/blogs/");

  container.innerHTML = '';
  container.appendChild(renderAccordion(container.getAttribute("data-collections-text"), collectionsTree));
  container.appendChild(renderAccordion(container.getAttribute("data-products-text"), productsTree));
  container.appendChild(renderAccordion(container.getAttribute("data-pages-text"), pagesTree));
  container.appendChild(renderAccordion(container.getAttribute("data-blog-text"), blogsTree));

  initAccordion(container);
})();